module.exports = __webpack_public_path__ + "img/bra.aa911b86.svg";